import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Clipboard } from '@capacitor/clipboard';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class CopyService {
  private readonly toastService: ToastService = inject(ToastService);

  copyToClipboard(value: string): Observable<void> {
    Clipboard.write({ string: value });

    return this.toastService.showToast({
      message: 'Skopiowano do schowka',
      position: 'bottom',
      duration: 2000
    });
  }
}
